// extracted by mini-css-extract-plugin
export default {"changeValue":"br_gy","positive":"br_gz","negative":"br_gB"};